(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-trotting/assets/javascripts/match.js') >= 0) return;  svs.modules.push('/components/themes/sport-trotting/assets/javascripts/match.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_trotting = svs.themes.sport_trotting || {};

  svs.themes.sport_trotting.formatModelData = function(data) {
    return data;
  };
})(svs);

 })(window);